import type { ReactNode } from "react";

/**
 * Pieces of a one-page record laid out like a printed form: lettered heading
 * bars and label/value pairs, two to a row. Shared by the student and staff
 * profile views.
 */
export function RecordSheet({ children }: { children: ReactNode }) {
  return (
    <article className="font-refined overflow-hidden rounded-md border border-gray-200 text-[13px] leading-5">
      {children}
    </article>
  );
}

export function SectionBar({ letter, title }: { letter: string; title: string }) {
  return (
    <h3 className="border-y border-gray-200 bg-gray-50 px-4 py-1 text-center text-[11px] font-semibold uppercase tracking-wide text-gray-600">
      Section {letter}: {title}
    </h3>
  );
}

export function Pairs({ rows }: { rows: [string, ReactNode][] }) {
  return (
    <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5 px-4 py-3 sm:grid-cols-[auto_1fr_auto_1fr]">
      {rows.map(([label, value]) => (
        <div key={label} className="contents">
          <dt className="whitespace-nowrap text-gray-500">{label}:</dt>
          <dd className="min-w-0 break-words font-medium text-gray-900">
            {value || <span className="font-normal text-gray-300">—</span>}
          </dd>
        </div>
      ))}
    </dl>
  );
}
